import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { Tooltip } from 'react-tooltip';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Toaster />
    <App />

    <Tooltip id="my-tooltip" />
  </BrowserRouter>
);